<template>
  <div class="table-responsive">
    <table class="table table-hover table-bordered bg-white table-striped">
      <thead>
          <th v-if="debt.deleted_at === null">{{ $t('app.action') }}</th>
          <th>{{ $t('app.type') }}</th>
          <th>{{ $t('addresses.address') }}</th>
          <th>{{ $t('addresses.owner') }}</th>
          <th>{{ $t('addresses.created_at') }}</th>
          <th>{{ $t('addresses.last_contact') }}</th>
      </thead>
      <tbody>
          <tr v-for="(address, index) in addresses" v-if="!loadAddresses">
            <td v-if="debt.deleted_at === null">
              <button @click.prevent="initAddDeparture(index)" class="btn btn-primary btn-sm min-width-125">
                {{ $t('departures.add') }}
              </button>
            </td>
            <td>{{address.type ? address.type.name : ''}}</td>
            <td>{{address.address}}</td>
            <td>
              <span v-if="address.contact_face">{{address.contact_face.fullname || ''}}</span><br v-if="address.contact_face">
              <span class="badge badge-pill" :class="{'badge-success': address.contact_face, 'badge-info': address.debtor}">{{address.who}}</span>
            </td>
            <td>{{address.created_at | datetimeFormat}}</td>
            <td>{{address.last_contact | datetimeFormat}}</td>
          </tr>
          <tr v-if="loadAddresses">
            <td colspan="5" class="text-center">
              <div class='sk-wave'>
                <div class='sk-rect sk-rect-1'></div>
                <div class='sk-rect sk-rect-2'></div>
                <div class='sk-rect sk-rect-3'></div>
                <div class='sk-rect sk-rect-4'></div>
                <div class='sk-rect sk-rect-5'></div>
              </div>
            </td>
          </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: [
    'debtorIin',
    'debtId',
  ],
  data() {
    return {
      address: {
        debtor: {}
      },
      errors: {},
      isProcessing: false,
      loadAddresses: false,
    }
  },
  computed: {
    ...mapGetters([
      'debt',
      'addresses',
    ]),
  },
  mounted() {
    if (this.debt.debtor_iin) {
      this.GET_ADDRESSES(this.debt.debtor_iin);
    }
  },
  methods: {
    ...mapActions([
      'INIT_ADDRESS',
      'GET_ADDRESSES',
    ]),
    initAddDeparture(index) {
      $('#add-departure').modal('show');
      this.address = this.addresses[index];
      this.address.debtor = this.addresses[index].debtor;
      this.INIT_ADDRESS(this.address);
    },
  },
};
</script>
